export default __webpack_public_path__ + "static/media/VegshelfFacebook-1200x630.47def438.png";